/* eslint-disable no-unused-vars */
import React, { createContext, useContext, useCallback, useEffect, useRef, useState } from 'react';
import { Provider, useDispatch, useSelector } from 'react-redux';

import { actions } from '../features/work-report-slice';
import { queryActiveOrder, queryPlanDueOrder, changeStatus } from '../features/work-report-thunk';

import { ZetaSection, ZetaGroup } from '../zeta-widget';
import { loadLayout, loadTemplate } from '../tools/layout-tool';
import { loadDataList } from '../tools/option-tool';

import { PillStatus } from './work-widget';
import { OrderMonthView } from './order-month-view';

// import { useAuth } from '../use-auth';
import { useHistory, useParams } from 'react-router-dom';

import { TextClickable } from '../widgets';

const defaultEnquiryLayout = [
  {
    name: 'filter',
    file: 'reports/work-report-filter',
    size: 'full',
    class: '',
  },
  {
    name: 'found',
    file: 'reports/work-report-found',
    size: 'full',
    class: 'table-responsive-sm',
  },
];

const delaySearch = 500;
let timerSearch = null;

function handleSearch(dispatch, page, cond) {
  if (timerSearch) clearTimeout(timerSearch);
  timerSearch = setTimeout(() => {
    dispatch(queryActiveOrder(cond))
  }, delaySearch);
}

export function WorkReportApp(props) {
  const enquiryLayout = useSelector((state) => state.reports.enquiryLayout);
  const searchData = useSelector((state) => state.reports.searchData);
  const searchFilter = useSelector((state) => state.reports.searchData.filter);
  const searchDue = useSelector((state) => state.reports.searchData.due);

  const dispatch = useDispatch();
  const { page } = useParams();
  const history = useHistory();

  useEffect(() => {
    loadTemplate(defaultEnquiryLayout, (v) => {
      // console.info(v);
      dispatch(actions.setEnquiryLaout(v));
    });
  }, [dispatch]);

  useEffect(() => {
    console.info('Will search...');
    const cond = { filter: searchFilter, due: searchDue };
    switch(page) {
      default:
        cond.sub = page;
    }

    handleSearch(dispatch, page, cond);
  }, [dispatch, page, searchFilter, searchDue]);

  useEffect(() => {
    dispatch(queryPlanDueOrder())
    .then(result => {
      // console.info(result);
    });
  }, [dispatch]);

  const title = () => {
    switch (page) {
      case 'no-due':
        return 'รายการสินค้า รอวางแผนกำหนดส่ง';

      case 'wait-approve':
        return 'รายการสินค้า รออนุมัติ';

      case 'pending':
        return 'รายการสินค้า รอผลิต/ยังไม่เริ่ม';

      case 'over-due':
        return 'รายการสินค้า เกินเวลากำหนด';
  
      case 'in-progress':
        return 'รายการสินค้า ระหว่างผลิต';

      case 'near-due':
        return 'รายการสินค้า ใกล้ถึงกำหนด';  
      
      default:
        return 'รายงานคำสั่งการผลิต'
    }
  }

  const handleFilterChange = useCallback(
    (e) => {
      const _data = { ...searchData };

      _data[e.target.name] = e.target.value;

      dispatch(actions.setSearchData(_data));
    },
    [dispatch, searchData]
  );

  const handleOpen = useCallback(
    (value) => {
      history.push(`/work-order/${value._id}`);
      // window.open(`/work-order/${value._id}`);
    },
    [history],
  );

  const handleApprove = useCallback(
    (value) => {
      dispatch(changeStatus({_id : value._id, work_status: 'A'}));
    },
    [dispatch],
  );

  const handleStart = useCallback(
    (value) => {
      dispatch(changeStatus({_id : value._id, work_status: 'Y'}));
    },
    [dispatch],
  )

  const handleFinish = useCallback(
    (value) => {
      dispatch(changeStatus({
        _id : value._id, 
        work_status: 'Z', 
        finish_date: new Date().toISOString()
      }))
      .then(res => {
        console.info(res);
        history.push(`/work-order/${value._id}?pane=status`);
      });
    },
    [dispatch, history],
  )

  const handleReject = useCallback(
    (value) => {
      dispatch(changeStatus({_id : value._id, work_status: 'X'}));
    },
    [dispatch],
  )

  const text_click = ({work_no, _id}) => <React.Fragment>
    <TextClickable text={work_no} click={() => history.push(`/work-order/${_id}`)} />
    <br />
  </React.Fragment>


  const _this = {
    pill_status: (v) => <PillStatus>{v}</PillStatus>,
    text_click,
    
    handlers: {
      handleOpen,
      handleApprove,
      handleStart,
      handleFinish,
      handleReject,
    },
    attrs: {
      showPeriodFilter: (!page.match(/over-due|no-due/)),
    }
  };

  return (
    <React.Fragment>
      <ZetaSection title={title()} name="search">
        <div className="row">
          {enquiryLayout &&
            enquiryLayout.map((t, i) => {
              return (
                <ZetaGroup
                  key={i}
                  app={_this}
                  em={t}
                  size={t.size}
                  addClass={t.class || ''}
                  template={t.template}
                  data={searchData}
                  onChange={handleFilterChange}
                />
              );
            })}
        </div>
      </ZetaSection>
      <OrderMonthView onOpen={handleOpen} />
    </React.Fragment>
  );
}
